import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useContext, useState } from 'react';
import { Button, Center, VStack } from '@chakra-ui/react';
import { hasValue, useT } from '@progress-fe/core';
import { Dialog } from '../../base';
import { useJsFieldFormData } from '../../../hooks';
import { JsFormConfigContext } from '../../../contexts';
import { JsFieldInspector } from '../../jsFormBase';
import { CatalystItem, CatalystDetails } from './components';
/**
 * Component renders "/schemas/jsf-catalysts-list" field of JsonSchema.
 * @param props : field props come from JsonSchema.
 * Value of props.formData is TBackgroundInformationFormData.
 */
const CatalystsListJsFieldFC = (props) => {
    const { runCallback, isInspector } = useContext(JsFormConfigContext) ?? {};
    const [selectedCatalyst, setSelectedCatalyst] = useState(null);
    const { t } = useT();
    const { fieldConfig, fieldValues, onChangeFieldValues, onChangeFieldConfig } = useJsFieldFormData({
        config: props.formData?.fieldConfig || null,
        values: props.formData?.fieldValues || null,
        onChange: props.onChange
    });
    const isEmpty = !fieldValues?.length;
    const handleAddCatalyst = async () => {
        const callbackCode = fieldConfig?.callbackCode || '';
        if (!callbackCode || !runCallback) {
            return;
        }
        const formDataResult = (await runCallback(callbackCode));
        if (hasValue(formDataResult)) {
            onChangeFieldConfig(formDataResult.fieldConfig);
            onChangeFieldValues(formDataResult.fieldValues);
        }
    };
    const handleSelectCatalyst = (catalyst) => {
        setSelectedCatalyst(catalyst);
    };
    const handleDeleteCatalyst = (catalyst) => {
        const newValues = fieldValues?.filter((item) => item.id !== catalyst.id) ?? [];
        onChangeFieldValues(newValues);
    };
    const handleUpdateCatalyst = (newCatalyst) => {
        const newValues = fieldValues?.map((item) => (item.id === newCatalyst.id ? newCatalyst : item)) ?? [];
        setSelectedCatalyst(newCatalyst);
        onChangeFieldValues(newValues);
    };
    return (_jsxs(JsFieldInspector, { isActive: isInspector, fieldCode: props.name, fieldType: props.uiSchema?.['ui:field']?.toString() ?? '', valueType: ['object'], children: [_jsxs(VStack, { "data-testid": "CatalystsListJsField-test", "data-name": props.name, pb: "2px", gap: "8px", w: "100%", children: [isEmpty && (_jsx(Center, { w: "100%", h: "64px", border: "1px solid", borderColor: "border", borderRadius: "4px", children: t('jsfields.CatalystsList.noItems') })), !isEmpty && (_jsx(VStack, { gap: "4px", w: "100%", children: fieldValues.map((item) => (_jsx(CatalystItem, { catalyst: item, isReadonly: !!props.schema.readOnly, onSelect: () => handleSelectCatalyst(item), onDelete: () => handleDeleteCatalyst(item) }, item.id))) })), !props.schema.readOnly && (_jsx(Button, { variant: "ghost", size: "smSquare", width: "100%", onClick: handleAddCatalyst, children: t('actions.add') }))] }), selectedCatalyst && fieldConfig && (_jsx(Dialog, { title: t('jsfields.CatalystsList.catalystDetails'), onClose: () => setSelectedCatalyst(null), children: _jsx(CatalystDetails, { catalyst: selectedCatalyst, config: fieldConfig.catalystConfig, onChange: handleUpdateCatalyst }) }))] }));
};
export const CatalystsListJsField = memo(CatalystsListJsFieldFC);
//# sourceMappingURL=CatalystsListJsField.js.map